module.exports = __webpack_public_path__ + "img/pb_gallery_2.77fec71b.jpg";